export default "__VITE_ASSET__ab7524fe__"